// Plain-text daily summary of the OTD Command Board (GET /api/otd/board),
// formatted for pasting straight into WhatsApp (*bold*, one fact per line).

export function fmtDay(iso) {
  if (!iso) return "";
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtTimeIST(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit" });
}

export function fmtPct(v) {
  return v === null || v === undefined ? "–" : `${Number(v).toFixed(v % 1 === 0 ? 0 : 1)}%`;
}

export function fmtLakh(v) {
  return `₹${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} L`;
}

const STATUS_LABEL = { open: "Pending", in_progress: "In Progress", done: "Done", blocked: "Blocked" };
const PRIORITY_LABEL = { high: "High", medium: "Medium", low: "Low" };

export function buildDailySummary(board) {
  if (!board) return "";
  const k = board.kpis || {};
  const m = board.meeting || {};
  const ps = board.pending_status || {};
  const lines = [];
  lines.push(`*OTD Command Board — ${fmtDay(board.date)}*`);
  lines.push(`Target OTD: ${board.target_otd_pct ?? 100}%`);
  lines.push(m.status === "closed"
    ? `Meeting: Closed at ${fmtTimeIST(m.closed_at)}${m.closed_by_name ? ` by ${m.closed_by_name}` : ""}`
    : "Meeting: Open");
  lines.push("");
  lines.push("*KPIs*");
  lines.push(`• OTD month to date: ${fmtPct(k.otd_mtd?.otd_pct)} (${k.otd_mtd?.on_time ?? 0}/${k.otd_mtd?.due ?? 0} on time)`);
  lines.push(`• OTD last 7 days: ${fmtPct(k.otd_7d?.otd_pct)} (${k.otd_7d?.on_time ?? 0}/${k.otd_7d?.due ?? 0} on time)`);
  lines.push(`• Overdue orders: ${k.overdue_orders ?? 0}`);
  lines.push(`• Red orders (>3 days late): ${k.red_orders ?? 0}`);
  lines.push(`• Value at risk: ${fmtLakh(k.value_at_risk_lakh)}`);
  lines.push(`• Blocked tasks: ${k.blocked_tasks ?? 0}`);
  lines.push("");
  lines.push(`*Pending orders:* 🔴 Red ${ps.red ?? 0} · 🟠 Amber ${ps.amber ?? 0} · 🟢 Green ${ps.green ?? 0}`);
  lines.push("");
  lines.push("*Department readiness*");
  for (const c of board.readiness || []) {
    const mark = c.ready ? "✅" : "❌";
    const owner = c.owner_name ? ` (${c.owner_name})` : "";
    const note = c.note ? ` — ${c.note.replace(/\s+/g, " ").trim()}` : " — no update";
    lines.push(`${mark} ${c.label}${owner}: ${c.live_count} ${c.count_label}${note}`);
  }
  const acts = board.open_actions || [];
  lines.push("");
  lines.push(`*Open actions (${acts.length})*`);
  if (!acts.length) lines.push("None");
  acts.forEach((a, i) => {
    const bits = [a.department_label, a.owner_name || "No owner", a.due_date ? `due ${fmtDay(a.due_date)}` : "no date",
      STATUS_LABEL[a.status] || a.status];
    const so = a.so_code ? ` [${a.so_code}]` : "";
    lines.push(`${i + 1}. [${PRIORITY_LABEL[a.priority] || a.priority}] ${a.description}${so} — ${bits.join(" / ")}`);
  });
  return lines.join("\n");
}
